import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RxAlertsDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RxAlertsDetailsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RxAlertsDetails = {
  isLoading: false,
  error: false,
  message: null,
  RxAlertsDetailsData: [],
  Items: [],
  Pagination: [],
};

const RxAlertsDetailsSlice = createSlice({
  name: "RxAlertsDetails",
  initialState,
  reducers: {
    loadingRxAlertsDetails: (
      state: RxAlertsDetails,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRxAlertsDetails: (
      state: any,
      action: PayloadAction<RxAlertsDetails>
    ) => {
      return action.payload;
    },
    clearData: (state: RxAlertsDetails, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingRxAlertsDetails, setRxAlertsDetails, clearData } =
  RxAlertsDetailsSlice.actions;
export default RxAlertsDetailsSlice.reducer;
